import React, { useState, useEffect, useRef } from "react";
import { TiTick } from "react-icons/ti";
import loading from '../../images/loading.gif';

const LoadingSpinner = ({ isLoading, loadedPercentage, globalState }) => {
  const [displayMessages, setDisplayMessages] = useState(["Initialising new map load"]);

  // Tracks whether this is a brand-new loading session.
  const wasLoadingRef = useRef(false);

  const LOADINGPARAM_startOfLoad = globalState.LOADINGPARAM_startOfLoad;
  const LOADINGPARAM_makeScene = globalState.LOADINGPARAM_makeScene;
  const LOADINGPARAM_initAnimation = globalState.LOADINGPARAM_initAnimation;
  const LOADINGPARAM_onAdd = globalState.LOADINGPARAM_onAdd;
  const LOADINGPARAM_createShapes = globalState.LOADINGPARAM_createShapes;
  const LOADINGPARAM_applyDateRange = globalState.LOADINGPARAM_applyDateRange;

  const LOADINGPARAM_resetMapAfterDatesReceived =
    globalState.LOADINGPARAM_resetMapAfterDatesReceived;

  const LOADINGPARAM_fetchKeyData = globalState.LOADINGPARAM_fetchKeyData;
  const LOADINGPARAM_fetchNumericData =
    globalState.LOADINGPARAM_fetchNumericData;

  const devDeployment = globalState.devDeployment;

  const loadingStages = [
    {
      key: "startOfLoad",
      complete: LOADINGPARAM_startOfLoad,
      message: "Initialising new map load",
    },
    {
      key: "makeScene",
      complete: LOADINGPARAM_makeScene,
      message: "Preparing 3D scene",
    },
    {
      key: "initAnimation",
      complete: LOADINGPARAM_initAnimation,
      message: "Initialising map animation",
    },
    {
      key: "onAdd",
      complete: LOADINGPARAM_onAdd,
      message: "Adding map layers",
    },
    {
      key: "createShapes",
      complete: LOADINGPARAM_createShapes,
      message: "Generating map features",
    },
    {
      key: "applyDateRange",
      complete: LOADINGPARAM_applyDateRange,
      message: "Applying date range",
    },
    {
      key: "resetMapAfterDatesReceived",
      complete: LOADINGPARAM_resetMapAfterDatesReceived,
      message: "Updating map data",
    },
    {
      key: "fetchKeyData",
      complete: LOADINGPARAM_fetchKeyData,
      message: "Loading category data",
    },
    {
      key: "fetchNumericData",
      complete: LOADINGPARAM_fetchNumericData,
      message: "Loading numeric data",
    },
  ];

  useEffect(() => {
    if (!isLoading) {
      setDisplayMessages(["Initialising new map load"]);
      wasLoadingRef.current = false;
      return;
    }

    if (!wasLoadingRef.current) {
      wasLoadingRef.current = true;
      setDisplayMessages(["Initialising new map load"]);
      return;
    }

    const completedMessages = loadingStages
      .filter((stage) => stage.complete)
      .map((stage) => stage.message);

    const currentStage = loadingStages.find((stage) => !stage.complete);

    const messages = [
      ...completedMessages,
      currentStage ? currentStage.message : "Finalizing",
    ];

    setDisplayMessages([...new Set(messages)]);
  }, [
    isLoading,
    LOADINGPARAM_startOfLoad,
    LOADINGPARAM_makeScene,
    LOADINGPARAM_initAnimation,
    LOADINGPARAM_onAdd,
    LOADINGPARAM_createShapes,
    LOADINGPARAM_applyDateRange,
    LOADINGPARAM_resetMapAfterDatesReceived,
    LOADINGPARAM_fetchKeyData,
    LOADINGPARAM_fetchNumericData,
  ]);

  return (
    <div
      className="loading"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 20,
        backgroundColor: "#fff",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        display: isLoading ? "block" : "none",
      }}
    >
      <img src={loading} style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100px",
        height: "100px",
        objectFit: "contain",
        display: "block",
      }}
        className='logo' alt='Skylark Logo' />

      <div
        className="loading_text"
        style={{
          position: "absolute",
          top: `calc(50% + ${devDeployment ? "60px" : "35px"})`,
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "left",
          fontSize: "12px",
          width: '175px',
          backgroundColor: '#fff'
        }}
      >
        {displayMessages.map((message, index) => {
          const isCurrent = index === displayMessages.length - 1;

          return (
            <p
              key={`${message}-${index}`}
              style={{
                margin: "0 0 6px 0",
                fontSize: isCurrent ? "12px" : "12px",
                lineHeight: "18px",
                opacity: isCurrent ? "1" : ".5"
              }}
            >
              {message}
              <span
                style={{
                  float: 'right'
                }}>{<TiTick />}</span>
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default LoadingSpinner;